var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 601.401,
    height: 601.418,
    viewBox: "0 0 601.401 601.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(-151.277 -250.484)",
    opacity: 0.337
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(151.277 250.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(167.058 364.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6907",
    "data-name": "Path 6907",
    d: "M178.555,326.869a34.053,34.053,0,1,1,19.471,44.025A34.044,34.044,0,0,1,178.555,326.869Z",
    transform: "translate(-176.253 -305.047)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(265.763 406.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6908",
    "data-name": "Path 6908",
    d: "M193.948,359.151a34.037,34.037,0,1,1,44.921,17.31A34.039,34.039,0,0,1,193.948,359.151Z",
    transform: "translate(-191.01 -311.268)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(364.955 366.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    d: "M227.655,371.09a34.075,34.075,0,1,1,44-19.524A34.088,34.088,0,0,1,227.655,371.09Z",
    transform: "translate(-205.839 -305.235)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(406.567 267.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6910",
    "data-name": "Path 6910",
    d: "M259.947,355.7a34.074,34.074,0,1,1,17.3-44.942A34.055,34.055,0,0,1,259.947,355.7Z",
    transform: "translate(-212.061 -290.478)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(366.226 168.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "M271.85,321.947a34.046,34.046,0,1,1-19.531-44.005A34.072,34.072,0,0,1,271.85,321.947Z",
    transform: "translate(-206.03 -275.647)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(267.532 126.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "M256.5,289.705a34.071,34.071,0,1,1-44.975-17.344A34.113,34.113,0,0,1,256.5,289.705Z",
    transform: "translate(-191.274 -269.423)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(126.682 265.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6913",
    "data-name": "Path 6913",
    d: "M190.488,293.152a34.052,34.052,0,1,1-17.364,44.915A33.992,33.992,0,0,1,190.488,293.152Z",
    transform: "translate(-170.216 -290.213)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(168.295 167.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6914",
    "data-name": "Path 6914",
    d: "M222.752,277.751a34.06,34.06,0,1,1-44.032,19.524A33.991,33.991,0,0,1,222.752,277.751Z",
    transform: "translate(-176.438 -275.457)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994",
    transform: "translate(50.544 312.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6915",
    "data-name": "Path 6915",
    d: "M342.918,303a21.27,21.27,0,0,0-30.032.916,19.8,19.8,0,0,0-2.99,4.2l-.06-.08c-10.394,18.535-27.758,39.544-73.175,13.933v.094a52.163,52.163,0,1,0,12.448,81.054,51.625,51.625,0,0,0,12.22-21.926h0c13.772-50.286,40.928-47.851,61.456-42.239l-.06-.107A21.181,21.181,0,0,0,342.918,303Z",
    transform: "translate(-158.833 -297.242)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(166.726 360.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6916",
    "data-name": "Path 6916",
    d: "M297.984,324.932A21.252,21.252,0,0,0,255.5,326.17a22.416,22.416,0,0,0,.836,5.124h-.114c5.752,20.407,8.354,47.563-41.871,61.616l.06.027a52.149,52.149,0,1,0,66.151,48.54,52.878,52.878,0,0,0-6.916-24.213l.054.034c-25.832-45.323-4.923-62.787,13.5-73.322l-.114-.06A21.279,21.279,0,0,0,297.984,324.932Z",
    transform: "translate(-176.203 -304.308)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(312.774 360.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6917",
    "data-name": "Path 6917",
    d: "M303.92,404.82a52.342,52.342,0,0,0-21.959-12.26l.033-.033c-50.366-13.739-47.878-40.875-42.286-61.362l-.114.06a21.179,21.179,0,1,0-34.9,9.779,18.632,18.632,0,0,0,4.254,3.023l-.107.033c18.474,10.415,39.55,27.765,13.939,73.228l.107-.033A52.131,52.131,0,1,0,303.92,404.82Z",
    transform: "translate(-198.038 -304.32)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(360.014 312.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6918",
    "data-name": "Path 6918",
    d: "M342.235,314.678a52.173,52.173,0,0,0-24.173,6.856v-.02c-45.3,25.865-62.787,4.923-73.288-13.525l-.06.107a21.03,21.03,0,0,0-19-10.816,21.22,21.22,0,1,0,1.271,42.42,21.042,21.042,0,0,0,5.09-.83v.094c20.414-5.732,47.57-8.354,61.6,41.9l.053-.06a52.139,52.139,0,1,0,48.507-66.131Z",
    transform: "translate(-205.101 -297.27)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(360.09 166.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6919",
    "data-name": "Path 6919",
    d: "M379.346,289.431a52.136,52.136,0,0,0-73.7,2.408,51.591,51.591,0,0,0-12.287,21.926v-.027c-13.772,50.339-40.928,47.871-61.4,42.286l.053.114a21.2,21.2,0,1,0,9.792,34.935,20.7,20.7,0,0,0,2.983-4.234l.033.073c10.421-18.521,27.792-39.57,73.255-13.932l-.02-.08a52.146,52.146,0,0,0,61.289-83.469Z",
    transform: "translate(-205.112 -275.339)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(312.946 50.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6920",
    "data-name": "Path 6920",
    d: "M319.76,308.512a52.162,52.162,0,1,0-97.408,27.544h-.06c25.838,45.3,4.93,62.78-13.491,73.295l.107.047a21.2,21.2,0,1,0,31.644,17.758,24.917,24.917,0,0,0-.883-5.083l.054.027c-5.7-20.5-8.294-47.6,41.952-61.677h-.08A52.207,52.207,0,0,0,319.76,308.512Z",
    transform: "translate(-198.064 -258.012)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(50.356 166.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6921",
    "data-name": "Path 6921",
    d: "M327.975,354.695a22.537,22.537,0,0,0-5.137.836l.047-.06c-20.467,5.7-47.624,8.334-61.617-41.925l-.053.06a52.161,52.161,0,1,0-48.567,66.125,51.48,51.48,0,0,0,24.173-6.836v.033c45.356-25.859,62.834-4.95,73.349,13.491l.047-.08a21.191,21.191,0,1,0,17.758-31.645Z",
    transform: "translate(-158.805 -275.407)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(166.265 50.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6922",
    "data-name": "Path 6922",
    d: "M291.848,412.114a21.867,21.867,0,0,0-4.207-3.043l.06-.027c-18.481-10.421-39.55-27.772-13.946-73.242l-.047.06a52.189,52.189,0,1,0-59.135,24.675h-.053c50.333,13.772,47.9,40.962,42.253,61.423l.12-.054a21.192,21.192,0,1,0,34.955-9.792Z",
    transform: "translate(-176.134 -258.041)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(77.666 458.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6923",
    "data-name": "Path 6923",
    d: "M164.974,339.117a31.33,31.33,0,1,0,40.487-17.979A31.418,31.418,0,0,0,164.974,339.117Z",
    transform: "translate(-162.888 -319.052)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(267.668 538.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6924",
    "data-name": "Path 6924",
    d: "M193.993,375.081a31.339,31.339,0,1,0,15.926-41.37A31.342,31.342,0,0,0,193.993,375.081Z",
    transform: "translate(-191.294 -331.031)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(458.626 461.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6925",
    "data-name": "Path 6925",
    d: "M239.918,379.955a31.315,31.315,0,1,0-18-40.52A31.43,31.43,0,0,0,239.918,379.955Z",
    transform: "translate(-219.844 -319.419)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(538.765 271.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6926",
    "data-name": "Path 6926",
    d: "M275.837,350.983a31.339,31.339,0,1,0-41.343-15.926A31.45,31.45,0,0,0,275.837,350.983Z",
    transform: "translate(-231.825 -291.015)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(461.073 80.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6927",
    "data-name": "Path 6927",
    d: "M280.792,305.031a31.341,31.341,0,1,0-40.547,17.979A31.415,31.415,0,0,0,280.792,305.031Z",
    transform: "translate(-220.21 -262.459)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(271.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6928",
    "data-name": "Path 6928",
    d: "M251.731,269.085a31.313,31.313,0,1,0-15.926,41.343A31.392,31.392,0,0,0,251.731,269.085Z",
    transform: "translate(-191.811 -250.484)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(0 267.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6929",
    "data-name": "Path 6929",
    d: "M169.907,293.183a31.315,31.315,0,1,0,41.316,15.906A31.332,31.332,0,0,0,169.907,293.183Z",
    transform: "translate(-151.277 -290.503)",
    fill: "#449b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(80.101 77.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6930",
    "data-name": "Path 6930",
    d: "M205.877,264.178A31.335,31.335,0,1,0,223.8,304.692,31.49,31.49,0,0,0,205.877,264.178Z",
    transform: "translate(-163.252 -262.096)",
    fill: "#449b23"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6931",
    "data-name": "Path 6931",
    d: "M244.011,393.1l-7.913-7.886c-29.37-26.019-48.56-43.55-48.56-65.048a30.649,30.649,0,0,1,31.029-31.089,33.907,33.907,0,0,1,25.444,11.9,34.014,34.014,0,0,1,25.444-11.9,30.667,30.667,0,0,1,31.089,31.089c0,21.5-19.2,39.029-48.627,65.048l-7.906,7.886",
    transform: "translate(206.28 219.516)",
    fill: "#fff",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a2dea020e4f7b5571b12aa76c2e92b82.svg";
export { ForwardRef as ReactComponent };